import { getThreadLoadType, threadPostLoadEvent, } from '#pplx/frontend/apps/ask/events/thread/analytics.js';
import { observePostLoadBlocking } from '#pplx/frontend/apps/ask/events/thread/observePostLoadBlocking.js';
import { useRearmedThreadLoadEvent } from '#pplx/frontend/apps/ask/events/thread/useRearmedThreadLoadEvent.js';
import { useCallback, useEffect, useEffectEvent, useState } from 'react';
export function useThreadPostLoadBlocking(threadKey) {
    const track = useRearmedThreadLoadEvent();
    const [firstLoad, setFirstLoad] = useState();
    if (firstLoad && firstLoad.deduplicationKey !== threadKey)
        setFirstLoad(undefined);
    const report = useEffectEvent((input, result) => {
        track(threadPostLoadEvent({
            name: 'thread blocking measured',
            data: {
                contextUUID: input.contextUUID,
                surface: input.surface,
                loadType: getThreadLoadType(input.pageStartedAtMs),
                contentSource: input.contentSource,
                threadState: input.threadState,
                loadedEntryCount: input.loadedEntryCount,
                firstContentAtMs: performance.timeOrigin + input.occurredAtMs,
                ...result,
            },
        }));
    });
    useEffect(() => {
        // Cached sidecars can have zero load duration and still need a post-load window.
        if (!firstLoad ||
            firstLoad.isInitialThreadSubmission ||
            firstLoad.isPartialLoad ||
            !firstLoad.wasDocumentVisible ||
            firstLoad.occurredAtMs < firstLoad.loadStartedAtMs) {
            return;
        }
        return observePostLoadBlocking(firstLoad.occurredAtMs, (result) => report(firstLoad, result));
    }, [firstLoad]);
    return useCallback((input) => {
        if (input.deduplicationKey !== threadKey)
            return;
        setFirstLoad((previous) => previous ?? input);
    }, [threadKey]);
}
//# sourceMappingURL=useThreadPostLoadBlocking.js.map